/**
 * @description Objeto que contiene los pasos para el componente
 * stepper durante los procesos de recuperación de contraseña
 * y registro de usuario
 */
export const stepsRegistroNuevoFlujo = [
  { title: "Validar identidad" },
  { title: "Ingresar tus datos" },
  { title: "Activar tu cuenta" },
];
